import React from 'react';

import { SkeletonBlock } from '../../../components/skeleton/skeleton';

function KpiCardSkeleton() {
  return (
    <div className="rounded-md border border-slate-200 bg-white p-5 dark:border-slate-700 dark:bg-slate-800/70">
      <div className="flex items-start gap-2">
        <SkeletonBlock className="h-10 w-10 shrink-0 rounded-md" />
        <div className="min-w-0 flex-1 text-end">
          <SkeletonBlock className="ml-auto h-3 w-20 rounded" />
        </div>
      </div>
      <SkeletonBlock className="mt-5 h-9 w-28 rounded-md" />
      <SkeletonBlock className="mt-2 h-3 w-36 max-w-full" />
    </div>
  );
}

export default function DashboardSkeleton() {
  return (
    <div className="dashboard-shell min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
      <div className="mx-auto max-w-5xl space-y-8">
        <div className="flex flex-col gap-2">
          <SkeletonBlock className="h-8 w-48 max-w-[80%] rounded-md sm:h-9" />
          <SkeletonBlock className="h-4 w-full max-w-xl rounded" />
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div className="flex flex-wrap gap-2">
              <SkeletonBlock className="h-9 w-28 rounded-md" />
              <SkeletonBlock className="h-9 w-36 rounded-md" />
              <SkeletonBlock className="h-9 w-32 rounded-md" />
            </div>
            <div className="flex flex-wrap gap-2">
              <SkeletonBlock className="h-9 w-full min-w-[12rem] rounded-md sm:w-48" />
              <SkeletonBlock className="h-9 w-40 rounded-md" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <KpiCardSkeleton key={i} />
          ))}
        </div>

        <div className="overflow-hidden rounded-md border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800/70">
          <div className="flex flex-col gap-3 border-b border-slate-100 px-5 py-4 dark:border-slate-700/70 sm:flex-row sm:items-center sm:justify-between">
            <div className="space-y-2">
              <SkeletonBlock className="h-3 w-28 rounded" />
              <SkeletonBlock className="h-5 w-40 rounded" />
            </div>
            <div className="flex flex-wrap gap-3">
              <SkeletonBlock className="h-9 w-52 rounded-md" />
              <SkeletonBlock className="h-9 w-40 rounded-full" />
            </div>
          </div>
          <div className="px-5 pb-5 pt-4">
            <SkeletonBlock className="h-[280px] w-full rounded-md sm:h-[320px]" />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="rounded-md border border-slate-200 bg-white p-5 dark:border-slate-700 dark:bg-slate-800/70"
            >
              <div className="mb-4 flex items-center justify-between gap-2">
                <SkeletonBlock className="h-4 w-32 rounded" />
                <SkeletonBlock className="h-8 w-24 rounded-full" />
              </div>
              <div className="space-y-3">
                {[0, 1, 2, 3, 4].map((row) => (
                  <div key={row} className="flex items-center gap-3">
                    <SkeletonBlock className="h-8 w-8 shrink-0 rounded-md" />
                    <div className="min-w-0 flex-1 space-y-2">
                      <SkeletonBlock className="h-3 w-3/4 max-w-[12rem] rounded" />
                      <SkeletonBlock className="h-3 w-16 rounded" />
                    </div>
                    <SkeletonBlock className="h-4 w-14 shrink-0 rounded" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
